import { NgModule } from '@angular/core';
import { FnxLinkModule } from '@farmnet/fnx-components';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { RouterModule } from '@angular/router';
import { TrackNavigationModule } from '../../analytics/directives/track-navigation.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    FnxLinkModule,
    TrackNavigationModule,
    TranslocoModule,
  ],
  exports: [FooterComponent],
})
export class FooterModule {}
